export default __webpack_public_path__ + "static/media/SZ02.32c12728.mp3";